import React, {Component} from "react";
import {
    addProjectInstitutionMappings, deleteInstitutionUserMappings, deleteProjectInstitutionMapping,
    getInstitutions,
    getProjectInstitutionMappings
} from "../../../../services/InstitutionService";
import { ToastContainer } from 'react-toastify';
import { toaster } from '../../../../config';
import CustomLoader from "../../../common/Loader";
import AddProjectInstitution from "./AddProjectInstitutionDialog";

class ProjectInstitutions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            Project_Institutions: [],
            Institution_Options: [],
            loading: true,
        }
    }

    loadInstitutionProjectMappings = async () => {
        const {data: Project_Institutions}  = await getProjectInstitutionMappings(
            parseInt(this.props.Project_ID)
        );
        let { data: Institution_Options} = await getInstitutions();
        Institution_Options = Institution_Options.filter(institution => {
            return (
                Project_Institutions.filter(pinstitutions => pinstitutions.Institution_ID === institution.Institution_ID).length !== 1
            );
        });
        this.setState({Project_Institutions, Institution_Options});
    }

    async componentDidMount() {
        this.loadInstitutionProjectMappings();
        this.setState({loading: false});
    }

    handleRemove = async (Institution_ID) => {
        const { data } = await deleteProjectInstitutionMapping({
            Project_ID: parseInt(this.props.Project_ID),
            Institution_ID,
        });
        if (Object.keys(data).length == 0) {
            toaster('error', data);
        } else {
            this.loadInstitutionProjectMappings();
            toaster('success', 'Removed');
        }
    };

    handleAdd = async (Institution_ID) => {
        const { data } = await addProjectInstitutionMappings({
            Project_ID: parseInt(this.props.Project_ID),
            Institution_ID,
        });
        if (Object.keys(data).length == 0) {
            toaster('error', data);
        } else {
            this.loadInstitutionProjectMappings();
            toaster('success', data);
        }
    };

    render() {
        if (this.state.loading) {
            return <CustomLoader loading={this.state.loading} />;
        }

        const {Project_Institutions, Institution_Options} = this.state;
        return(
            <React.Fragment>
                <AddProjectInstitution
                    Institutions={Institution_Options}
                    handleAdd={this.handleAdd}
                />
                <table className="table table-hover table-borderless">
                    <thead className="border-bottom">
                    <tr>
                        <th>Institution Name</th>
                        <th />
                    </tr>
                    </thead>
                    <tbody>
                    {Project_Institutions.map((institution, idx) => (
                        <tr className="border-bottom" key={"projectInstitution" + institution.Institution_ID}>
                            <td>{institution.Institution_Name}</td>
                            <td>
                                <button
                                    className="btn btn-outline-danger btn-sm rounded-0"
                                    onClick={() => this.handleRemove(institution.Institution_ID)}
                                >
                                    Remove
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
                <ToastContainer/>
            </React.Fragment>
        );
    }
}

export default ProjectInstitutions;